import { template } from 'lodash'

export enum DepositMethod {
  /**
   * 按固定值收取整场保证金
   */
  SESSION_FIXED = 0,
  /**
   * 按比例收取整场保证金
   */
  SESSION_PROPORTIONAL = 1,
  /**
   * 按固定值收取每份保证金
   */
  PIECE_FIXED = 2,
  /**
   * 按比例收取每份保证金
   */
  PIECE_PROPORTIONAL = 3,
  /**
   * 不收取
   */
  NONE = 4
}

export const DepositMethodTextMap = {
  [DepositMethod.NONE]: '不收取',
  [DepositMethod.SESSION_FIXED]: '按固定值收取整场保证金',
  [DepositMethod.SESSION_PROPORTIONAL]: '按比例收取整场保证金',
  [DepositMethod.PIECE_FIXED]: '按固定值收取每份保证金',
  [DepositMethod.PIECE_PROPORTIONAL]: '按比例收取每份保证金'
}

export const DepositMethodUnitMap = {
  [DepositMethod.SESSION_FIXED]: '元',
  [DepositMethod.SESSION_PROPORTIONAL]: '%',
  [DepositMethod.PIECE_FIXED]: '元',
  [DepositMethod.PIECE_PROPORTIONAL]: '%',
  [DepositMethod.NONE]: ''
}

export const DepositMethodTemplateMap = {
  [DepositMethod.SESSION_FIXED]: template(
    '整场收取 ${ value } ' + DepositMethodUnitMap[DepositMethod.SESSION_FIXED]
  ),
  [DepositMethod.SESSION_PROPORTIONAL]: template(
    '整场收取 ${ value }' +
      DepositMethodUnitMap[DepositMethod.SESSION_PROPORTIONAL]
  ),
  [DepositMethod.PIECE_FIXED]: template(
    '每份收取 ${ value } ' + DepositMethodUnitMap[DepositMethod.PIECE_FIXED]
  ),
  [DepositMethod.PIECE_PROPORTIONAL]: template(
    '每份收取 ${ value }' +
      DepositMethodUnitMap[DepositMethod.PIECE_PROPORTIONAL]
  ),
  [DepositMethod.NONE]: template('')
}
